// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
export enum SituacaoCadastral {
  EM_INTEGRACAO = 'EM_INTEGRACAO',
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO'
}

export enum SituacaoCliente {
  ADIMPLENTE = 'ADIMPLENTE',
  INADIMPLENTE = 'INADIMPLENTE',
  BLOQUEADO = 'BLOQUEADO',
}

/**
 * Possíveis perfis de um contato de um cliente
 */
export enum ContactProfile {
  Atendimento = 'ATENDIMENTO',
  Diretoria = 'DIRETORIA',
  Expedição = 'EXPEDICAO',
  Financeiro = 'FINANCEIRO',
  Geral = 'GERAL',
  TI = 'TI',
}

export interface Telefone {
  ddd: string;
  numero: string;
}

export interface PlanoContrato {
  id: number;
  plano: string;
  recorrencia: number;
  codigo: string;
  tipo: string;
  vencimento1aQuinzena: number;
  vencimento2aQuinzena: number;
}

export interface Horarios {
  1: string;
  2: string;
  3: string;
  4: string;
  5: string;
}

export interface ClienteResponse {
  id: number;
  nome: string;
  email: string;
  cpf: string;
  cnpj: string;
  razaoSocial: string;
  inscriacaoEstadual: string;
  diasAdicionaisParaPostagem: number;
  imporCorreios: boolean;
  planoContrato: PlanoContrato;
  telefone: Telefone;
  freedom: boolean;
  horaLimiteMesmoDiaPostagem: string;
  horaLimiteColeta: string;
  formaColeta: string;
  modoDemonstracao: boolean;
  grupoConfiguracaoId: number;
  dataAtivacao: Date;
  tipoVeiculoColeta: String;
  dataInicio: Date;
  coletaAtiva: boolean;
  podeTransferirColeta: boolean;
  ignoraValidacaoChaveAcessoNfe: boolean;
  pj: boolean;
  idIugu: string;
  idMixpanel: string;
  categoriaCliente: string;
  dataHoraCriacao: Date;
  inadimplente: boolean;
  notificaDestinatario: boolean;
  situacao: SituacaoCliente;
  situacaoCadastral: SituacaoCadastral;
  horariosInicioExpedicao: Horarios;
  horariosFimExpedicao: Horarios;
  horariosExcecao: string;
  inicioExpedientePausa: any[];
  fimExpedientePausa: any[];
  tempoParada: number;
}

export interface ClientesResponse {
  clientes: ClienteResponse[];
  total: number;
}

/**
 * Contato de um cliente
 */
export interface CustomerContact {
  /**
   * ID do contato no banco de dados
   */
  id?: number;

  /**
   * ID do cliente a quem este contato pertence
   */
  clienteId?: number;

  /**
   * E-mail do contato
   */
  email: string;

  /**
   * Telefone do contato
   */
  telefone: string;

  /**
   * ID no Zendesk do contato
   */
  zendeskId?: number;

  /**
   * Perfil do contato
   */
  perfil: ContactProfile;
}

export interface CustomerCommercial {
  nomeGerenteConta: string;
  emailGerenteConta: string;
  integracao: string;
}
